export const whiteLocaleList = ['eu', 'uk', 'de', 'fr', 'it', 'es', 'nl'];

export const solutionConfig: Record<
    string,
    {
        item1: { link: string; disable: boolean };
        item2: { link: string; disable: boolean };
    }
> = {
    uk: {
        item1: { link: 'https://energy-calculator.ecoflow.com/uk/en/bkw?terminal=ecoflow', disable: false },
        item2: { link: 'https://energy-calculator.ecoflow.com/uk/en/eu?terminal=ecoflow', disable: false },
    },
    eu: {
        item1: { link: 'https://energy-calculator.ecoflow.com/eu/en/bkw?terminal=ecoflow', disable: false },
        item2: { link: '', disable: true },
    },
    de: {
        item1: { link: 'https://energy-calculator.ecoflow.com/de/de/bkw?terminal=ecoflow', disable: false },
        item2: { link: 'https://energy-calculator.ecoflow.com/de/de/eu?terminal=ecoflow', disable: false },
    },
    fr: {
        item1: { link: 'https://energy-calculator.ecoflow.com/fr/fr/bkw?terminal=ecoflow', disable: false },
        item2: { link: 'https://energy-calculator.ecoflow.com/fr/fr/eu?terminal=ecoflow', disable: false },
    },
    it: {
        item1: { link: 'https://energy-calculator.ecoflow.com/it/it/bkw?terminal=ecoflow', disable: false },
        item2: { link: '', disable: true },
    },
    es: {
        item1: { link: 'https://energy-calculator.ecoflow.com/es/es/bkw?terminal=ecoflow', disable: false },
        item2: { link: '', disable: true },
    },
    nl: {
        item1: { link: 'https://energy-calculator.ecoflow.com/nl/nl/bkw?terminal=ecoflow', disable: false },
        item2: { link: '', disable: true },
    },
};
